import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { useI18nextInstance } from "@squide/i18next";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFilterOptionsClient } from "../../api/filterOptionsQuery.ts";
import { reviewCyclesI18NextInstanceKey } from "../../i18n/i18next.ts";
import { AttributeFilterPanel, type AttributeFilterPanelLabels } from "./AttributeFilterPanel.tsx";

export interface DepartmentFilterPanelProps {
    selectedValues: string[];
    onSelectionChange: (departments: string[]) => void;
    onBack: () => void;
    maxSelections?: number;
}

export function DepartmentFilterPanel({ selectedValues, onSelectionChange, onBack, maxSelections }: DepartmentFilterPanelProps) {
    const i18nextInstance = useI18nextInstance(reviewCyclesI18NextInstanceKey);
    const { t } = useTranslation("DepartmentFilterPanel", { i18n: i18nextInstance });
    const client = useFilterOptionsClient();

    const { data, isPending, isError } = useQuery(createQueryOptions(client.listDepartments.queryOptions(), { throwOnError: false }));

    const getResultsAnnouncement = useCallback((count: number) => t("liveRegion.results", { count }), [t]);

    const labels = useMemo<AttributeFilterPanelLabels>(
        () => ({
            title: t("title"),
            back: t("back"),
            searchPlaceholder: t("searchPlaceholder"),
            loading: t("loading"),
            empty: t("empty"),
            noMatches: t("noMatches"),
            error: t("error"),
            getResultsAnnouncement
        }),
        [t, getResultsAnnouncement]
    );

    return <AttributeFilterPanel labels={labels} options={data?.items ?? []} isPending={isPending} isError={isError} selectedValues={selectedValues} onSelectionChange={onSelectionChange} onBack={onBack} maxSelections={maxSelections} />;
}
